import Icon, { type IconName } from "./Icon";

export interface FabProps {
  onClick: () => void;
  iconName: IconName;
  "aria-label": string;
}

/**
 * Floating action button. Reuses the `.fab` and `.fab__icon` classes from
 * the legacy stylesheet so positioning + animations are unchanged.
 */
export default function Fab({ onClick, iconName, "aria-label": ariaLabel }: FabProps) {
  return (
    <button type="button" className="fab" onClick={onClick} aria-label={ariaLabel}>
      <Icon name={iconName} className="fab__icon" />
    </button>
  );
}
